import { getLocation } from './windowUtils';
export const getSurveyTypeFromPath = () => {
  const [surveyPath] = getLocation().pathname.split('/')[1];
  return surveyPath ? surveyPath.toUpperCase() : '';
};